import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FastQuoteService } from '@app-services/fast-quote.service';
import { reloadCurrentRoute } from '@app-utils/router-utils';

export interface DialogFastQuoteRulesData {
  mode: 'rules' | 'cancel';
  expirationTimeLeft: number;
  fastQuoteId?: string;
}

@Component({
  selector: 'app-dialog-fast-quote-rules',
  templateUrl: './dialog-fast-quote-rules.component.html',
  styleUrls: ['./dialog-fast-quote-rules.component.scss'],
})
export class DialogFastQuoteRulesComponent {
  loading = false;

  constructor(
    private dialogRef: MatDialogRef<DialogFastQuoteRulesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogFastQuoteRulesData,
    private fastQuoteService: FastQuoteService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  cancelFastQuote(): void {
    this.loading = true;
    if (this.data.fastQuoteId) {
      this.fastQuoteService.cancelFastQuote(this.data.fastQuoteId).subscribe(
        (response: { success?: boolean }) => {
          if (response.success) {
            this.loading = false;
            this.dialogRef.close(true);
            this.reload();
          }
        },
        (error) => {
          const message = error.error?.message ? error.error.message : 'Erro ao cancelar cotação rápida';
          this.toastr.error(message);
          this.loading = false;
          this.dialogRef.close();
        }
      );
    } else {
      this.loading = false;
      this.dialogRef.close();
      this.reload();
    }
  }

  private reload(): void {
    reloadCurrentRoute(this.router);
  }
}
